<template>
  <div>
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li class='breadcrumb-item'>
          <a href='/archive-purchase-payments'>{{translations('navbar.purchase_management')}}</a>
        </li>
        <li class='breadcrumb-item'>
          <router-link to='/archive-purchase-payments'>{{translations('payment.archive_payment')}}</router-link>
        </li>
        <li class='breadcrumb-item active' aria-current='page'>{{translations('payment.payment_details')}}</li>
      </ol>
    </nav>
    <div class='container-fluid main-container'>
      <div class='d-flex flex-wrap'>
        <div class='left-container'>
          <h5 class='mb-3'>Information</h5>
          <table class='table table-sm table-borderless table-information'>
            <tbody>
              <tr>
                <th>{{translations('payment.withdrawal_date')}}</th>
                <td>{{ $invoiceTools.formatDateAt(paymentInfo.paid_at) }}</td>
              </tr>
              <tr>
                <th>{{translations('payment.supplier')}}</th>
                <td>{{paymentInfo.kaishu_partner_name}}</td>
              </tr>
              <tr>
                <th>{{translations('payment.client_order_number')}}</th>
                <td>{{paymentInfo.purchase_number}}</td>
              </tr>
              <tr>
                <th>{{translations('payment.name')}}</th>
                <td>{{paymentInfo.name}}</td>
              </tr>
              <tr>
                <th>{{translations('payment.total_withdrawal_amount')}}</th>
                <td>{{Number(paymentInfo.total_paid).toLocaleString()}}</td>
              </tr>
              <tr>
                <th>{{translations('payment.transfer_fee')}}</th>
                <td>{{Number(paymentInfo.total_fee).toLocaleString()}}</td>
              </tr>
              <tr>
                <th>{{translations('payment.remarks')}}</th>
                <td>{{paymentInfo.memo}}</td>
              </tr>
              <tr>
                <th>{{translations('common.last_updated_by')}}</th>
                <td>{{paymentInfo.updated_by}}</td>
              </tr>
              <tr>
                <th>{{translations('common.last_update_time')}}</th>
                <td>{{paymentInfo.updated_at}}</td>
              </tr>
            </tbody>
          </table>
          <hr>
          <div class='form-inline'>
            <div class='form-group'>
              <a class='btn btn-link btn-sm text-danger' @click.self="deletePayment()" data-href='#'>{{translations('common.delete')}}</a>
            </div>
          </div>
        </div>
        <div class='right-container'>
          <div class="form-inline justify-content-end">
            <div class="form-check">
              <label class="form-check-label">{{translations('common.tax_included')}}</label>
            </div>
          </div>
          <div class='table-scroll mb-4'>
            <table class='table table-sm table-striped table-800'>
              <thead>
                <tr>
                  <th></th>
                  <th>{{translations('payment.item_name')}}</th>
                  <th>{{translations('payment.amount_money')}}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
                <template v-for="(detail, i) in paymentDetails">
                  <tr :key="i">
                    <td>
                      <button tabindex="-1" @click="deleteDetail(i)" class='btn-change minus'><i></i></button>
                    </td>
                    <td>{{ detail.item_name }}</td>
                    <td>{{ Number(detail.paid).toLocaleString() }}</td>
                  </tr>
                </template>
                <tr class='bg-lightgreen'>
                  <td>
                    <button
                      class='btn-change plus'
                      type='button'
                      data-toggle='modal'
                      data-target='#SinglePaymentsModal'
                    >
                      <i></i>
                    </button>
                  </td>
                  <td></td>
                  <td class='font-weight-bold'>{{ Number(grandTotalUnitPrice).toLocaleString() }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class='form-inline'>
            <div class='form-group'>
              <button class='btn btn-sm btn-primary' @click="updatePayment()">{{translations('common.update')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SinglePaymentsModal :details="paymentDetails" :is-purchase="true"/>
    <vue-element-loading :active='isLoading' :is-full-screen='true'/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import SinglePaymentsModal from '@/components/SinglePaymentsModal'
import { mapState } from 'vuex'

export default {
  name: 'SinglePurchasePayments',
  props: {},
  components: {
    VueElementLoading,
    SinglePaymentsModal
  },

  data () {
    return {
      paymentId: 0,
      paymentInfo: {},
      paymentDetails: [],
      tempInfo: {},
      grandTotalUnitPrice: null,
      grandTotalUnitPriceWithTax: null,
      isLoading: false
    }
  },

  watch: {
    paymentDetails: {
      handler (v) {
        this.calcGrandTotals()
      },
      deep: true
    }
  },

  created () {
    if (!this.$route.query.payment_id) {
      this.$router.replace('archive-purchase-payments')
      return
    }

    this.paymentId = Number(this.$route.query.payment_id)
    this.getPayments()
  },

  computed: {
    ...mapState(['currentLanguage']),
    confirmationDeletePaymentMessage () {
      return this.translations('payment.delete_payment')
    },
    confirmationUpdatePaymentMessage () {
      return this.translations('payment.update_payment')
    },
    confirmButtonText () {
      return this.translations('common.yes')
    },
    cancelButtonText () {
      return this.translations('common.no')
    }
  },

  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    async getPayments () {
      this.isLoading = true
      try {
        const response = await this.$http.post(
          this.$api_url.purchase_payments_detail,
          { payment_id: this.paymentId }
        )
        let result = response.data
        if (result.status === true) {
          this.paymentInfo = result.information
          this.paymentDetails = result.details
        } else {
          this.$toastr.error(result.message, 'エラー')
        }
      } catch (error) {
        console.log('SinglePurchasePayments:getPayments:catch(error): ', JSON.stringify(error))
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
      this.isLoading = false
    },

    popoverButtons () {
      window.$('button[data-toggle="popover-x"]').each(function () {
        let targetID = window.$(this).attr('data-target')
        window.$(this).popoverButton({
          target: targetID,
          trigger: 'click'
        })
      })
    },

    /**
     * @param field : invoices information props
     * @param value : value
     * @param ref   : reference trigger
     */
    updateField (field, value, ref) {
      let $this = this
      let val = ''
      const rg = /^\s+$/
      if (
        value === '-' ||
        value === '' ||
        rg.test(value) === true ||
        typeof value === 'undefined'
      ) {
        this.$refs[ref].innerText = '-----------'
        val = ''
      } else if (
        field === 'defraymented_at'
      ) {
        this.$refs[ref].innerText = this.$invoiceTools.formatDateAt(value)
        val = value
      } else if (field === 'partners_id') {
        this.partners.forEach(function (v) {
          if (v.id === parseInt(value)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
          }
        })
      } else {
        this.$refs[ref].innerText = value
        val = value
      }
      this.paymentInfo[field] = val
      window.$('#popover-' + ref).popoverX('hide')
    },

    deleteDetail (i) {
      this.paymentDetails.splice(i, 1)
    },

    calcGrandTotals () {
      this.grandTotalUnitPrice = 0
      this.paymentDetails.forEach(v => {
        this.grandTotalUnitPrice += parseInt(v.paid)
      })
    },

    updatePayment () {
      this.$dialog.confirm(this.confirmationUpdatePaymentMessage, {
        okText: this.confirmButtonText,
        cancelText: this.cancelButtonText
      }).then(async () => {
        try {
          this.isLoading = true

          let paramUpdate = {
            payment_id: this.paymentId,
            information: this.paymentInfo,
            details: this.paymentDetails
          }
          let updateInvoice = await this.$http.post(this.$api_url.purchase_payments_update, paramUpdate)
          let $data = this.$invoiceTools.prepareResult(updateInvoice.data)
          if ($data.success === true) {
            this.$toastr.success('支払更新に成功しました。', 'Success')
            this.getPayments()
          } else {
            this.$toastr.error($data.data, 'エラー')
          }
          this.isLoading = false
        } catch (error) {
          console.log('SinglePurchasePayments:updatePayment:catch(error): ', error)
          this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        }
      })
    },

    deletePayment () {
      this.$dialog.confirm(this.confirmationDeletePaymentMessage, {
        okText: this.confirmButtonText,
        cancelText: this.cancelButtonText
      })
        .then(async () => {
          this.isLoading = true
          try {
            let del = await this.$http.post(this.$api_url.purchase_payments_delete, { payment_id: this.paymentId })
            let $data = this.$invoiceTools.prepareResult(del.data, '', 'SinglePurchasePayments:deletePayment')
            if ($data.success === true) {
              this.$toastr.success('支払を削除しました', 'Success')
              this.$router.replace('archive-purchase-payments')
              this.isLoading = false
            } else {
              this.$toastr.error($data.data, 'エラー')
            }
            this.isLoading = false
          } catch (error) {
            this.isLoading = false
            console.log('SinglePurchasePayments:deletePayment:catch(error): ', error)
            this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
          }
        }).catch(() => { console.log('Clicked `Cancel`') })
    }
  }
}
</script>
